import { render, staticRenderFns } from "./MessageFormWidget.vue?vue&type=template&id=644c095c"
import script from "./MessageFormWidget.vue?vue&type=script&lang=js"
export * from "./MessageFormWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports